/**
 * AutomationMomentCard — the automation promise card (spec: automation as a
 * lock-screen "moment", not a rule builder). Static copy in two variants:
 *   - 'delay' (default, the flight-bound travel canvas): the delay→QR moment;
 *     the threshold is set at generation (Step 2 delay-threshold input,
 *     default 90).
 *   - 'update' (the generic canvas — no flight, no delay events): the
 *     operator-update push moment, explained through the existing
 *     changeMessage/notice mechanics (a rewritten field's notification copy
 *     surfaces on the lock screen).
 */
import { useT } from '../../i18n';

export interface AutomationMomentCardProps {
  variant?: 'delay' | 'update';
}

export function AutomationMomentCard({
  variant = 'delay',
}: AutomationMomentCardProps): JSX.Element {
  const t = useT();
  const delay = variant === 'delay';
  return (
    <div className="rounded-xl bg-emerald-50 ring-1 ring-emerald-200 p-4 flex gap-3">
      <span aria-hidden="true" className="text-xl leading-none">
        {delay ? '⚡' : '🔔'}
      </span>
      <div className="space-y-1">
        <p className="text-sm font-semibold text-emerald-900">
          {t(delay ? 'moment.title' : 'moment.updateTitle')}
        </p>
        <p className="text-xs text-emerald-800">{t(delay ? 'moment.body' : 'moment.updateBody')}</p>
      </div>
    </div>
  );
}
